import { TeamsService } from "@/common/api.service";
import {
  FETCH_TEAMS,
  GET_TEAM,
  ADD_TEAM,
  EDIT_TEAM,
  DELETE_TEAM,
  MAKE_TEAM_LEAD,
  SEND_INVITATION_TO_MEMBER
} from "./actions.type";
import { SET_TEAMS, SET_STARTUP_APPLICATION } from "./mutations.type";
import { async } from "q";

const initialState = {
  teams: null
};

export const state = { ...initialState };

// initial actions
const actions = {
  async [FETCH_TEAMS](context, app_id) {
    const { data } = await TeamsService.getAll(app_id);
    context.commit(SET_TEAMS, data.data.teams);
    context.commit(SET_STARTUP_APPLICATION, data.data.startup_application);
    return data;
  },
  async [GET_TEAM](context, playload) {
    const { data } = await TeamsService.get(playload.app_id, playload.team_id, playload.ecosystem);
    context.commit(SET_STARTUP_APPLICATION, data.data.startup_application);
    return data;
  },
  async [ADD_TEAM](context, playload) {
    const { data } = await TeamsService.post(playload.app_id, playload.team);
    context.commit(SET_STARTUP_APPLICATION, data.data.startup_application);
    return data;
  },
  async [EDIT_TEAM](context, playload) {
    const { data } = await TeamsService.put(
      playload.app_id,
      playload.team.user_id,
      playload.team,
      playload.ecosystem
    );
    context.commit(SET_STARTUP_APPLICATION, data.data.startup_application);
    return data;
  },
  async [DELETE_TEAM](context, playload) {
    const { data } = await TeamsService.destroy(
      playload.app_id,
      playload.user_id,
      playload.ecosystem
    );
    context.commit(SET_STARTUP_APPLICATION, data.data.startup_application);
    return data;
  },
  async [MAKE_TEAM_LEAD](context, playload) {
    const { data } = await TeamsService.makeLead(
      playload.app_id,
      playload.team_id
    );
    context.commit(SET_STARTUP_APPLICATION, data.data.startup_application);
    return data;
  },
  async [SEND_INVITATION_TO_MEMBER](context, playload) {
    const { data } = await TeamsService.sendInvitationToMember(
      playload.app_id,
      playload.email,
      playload.resend,
    );
    return data;
  }
};

// initial mutation
const mutations = {
  [SET_TEAMS](state, teams) {
    state.teams = teams;
  }
};

const getters = {
  teams(state) {
    return state.teams;
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};
